import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface Props {
  id: string
  value: string
  onChange: (value: string) => void
  /** Enter in the field: same as "Find the pages". */
  onSubmit: () => void
  searching: boolean
  error: string
}

/** The address of the site whose pages are looked for. */
export function SiteAddressField({ id, value, onChange, onSubmit, searching, error }: Props) {
  const { t } = useTranslation()
  return (
    <div className="min-w-0 space-y-2 py-2">
      <Label htmlFor={id}>{t('manager.aiAgents.siteImport.addressLabel')}</Label>
      <Input
        id={id}
        type="url"
        inputMode="url"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !searching) {
            e.preventDefault()
            onSubmit()
          }
        }}
        placeholder={t('manager.aiAgents.siteImport.addressPlaceholder')}
        className="text-base sm:text-sm"
        autoFocus
      />
      {error ? <p className="text-sm text-red-600 dark:text-red-400">{error}</p> : null}
      {searching ? <p className="text-xs text-slate-500 dark:text-slate-400">{t('manager.aiAgents.siteImport.searching')}</p> : null}
    </div>
  )
}
